import React, { useEffect, useState } from 'react';
import { Select, Spin } from 'antd';
import { useSearchParticipantTiNsQuery } from '../../graphql/generated';

interface Props {
  dcId: string;
  signatureDate: string;
  onChange: (tin: string | undefined) => void;
}

const ParticipantTINSearchSelect: React.FC<Props> = ({
  dcId,
  signatureDate,
  onChange,
}) => {
  const [search, setSearch] = useState('');
  const [query, setQuery] = useState('');
  useEffect(() => {
    const timeout = setTimeout(() => setQuery(search.trim()), 150);
    return () => clearTimeout(timeout);
  }, [search]);

  const { data, loading } = useSearchParticipantTiNsQuery({
    variables: {
      dc_id: dcId,
      signature_date: signatureDate,
      query: `%${query}%`,
    },
    skip: !dcId || !signatureDate || !query,
    fetchPolicy: 'cache-and-network',
  });
  const participants =
    query && query === search.trim()
      ? data?.analytics_analytics_cms_active_dce_participants || []
      : [];

  return (
    <Select<string>
      aria-label="Search for TIN by Legal Business Name"
      placeholder="Search by Legal Business Name"
      style={{ width: '100%' }}
      showSearch
      allowClear
      filterOption={false}
      disabled={!dcId || !signatureDate}
      onSearch={setSearch}
      notFoundContent={loading ? <Spin size="small" /> : 'No results'}
      onChange={(value) => {
        onChange(
          participants.find(
            (p) => JSON.stringify([p.legal_business_name, p.tin]) === value
          )?.tin || undefined
        );
      }}
      options={participants.map((participant) => ({
        value: JSON.stringify([
          participant.legal_business_name,
          participant.tin,
        ]),
        label: `${participant.legal_business_name} — TIN: ${participant.tin}`,
      }))}
    />
  );
};

export default ParticipantTINSearchSelect;
